export type DocumentationEvent={id:string;text:string;created_at:string;actor_name:string;event_type?:string;metadata:string};
export type MailHeader={date:string;from:string;subject:string};
/** Older email events retain their original text; extract only their explicit headers. */
export function documentationPresentation(entry:DocumentationEvent){
 let metadata:Record<string,unknown>={};try{metadata=JSON.parse(entry.metadata);}catch{}
 const mail=metadata.mail as Partial<MailHeader>|undefined;
 let header:MailHeader|null=mail&&typeof mail.from==="string"&&typeof mail.subject==="string"?{date:typeof mail.date==="string"?mail.date:entry.created_at,from:mail.from,subject:mail.subject}:null;
 let text=mail&&typeof (mail as {body?:unknown}).body==="string"?(mail as {body:string}).body:entry.text;
 if(entry.event_type==="mail_added"){
  const old=/^E-Mail hinzugefügt: ([^\n]*)\nAbsender: ([^\n]*)\n\n([\s\S]*)$/.exec(text);
  if(old){header=header??{date:entry.created_at,subject:old[1]!,from:old[2]!};text=old[3]!;}
 }
 if(header&&entry.event_type==="task_linked")text=text.replace(/^Inbox-Eintrag hinzugefügt: [^\n]*\n\n/,"");
 const long=text.length>320||text.split("\n").length>6;
 const teaser=text.replace(/\s+/g," ").trim().slice(0,220);
 return {header,text,linkedTaskId:typeof metadata.linkedTaskId==="string"?metadata.linkedTaskId:null,teaser:teaser+(text.replace(/\s+/g," ").trim().length>220?" …":""),expandable:Boolean(header)||long};
}
